import { apis } from "service";

const BASE_URL = 'https://xxl6-bbr3-kxzs.m2.xano.io/api:';

const get_deal_stats = BASE_URL + '7zIvT_vz/unutilized_deal_l2_v3'

export const getDealStats = async (): Promise<{
    name: string;
    today: number;
}[]> => {
    return (await apis.get(get_deal_stats,{})).data
}